import { render } from "./CourseOrCollectionCard.vue?vue&type=template&id=7a059217&scoped=true"
import script from "./CourseOrCollectionCard.vue?vue&type=script&lang=js"
export * from "./CourseOrCollectionCard.vue?vue&type=script&lang=js"

import "./CourseOrCollectionCard.vue?vue&type=style&index=0&id=7a059217&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a059217"]])

export default __exports__